import { render, staticRenderFns } from "./_SslDetails.vue?vue&type=template&id=45aa0bc8"
import script from "./_SslDetails.vue?vue&type=script&lang=ts"
export * from "./_SslDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports